// The overview pages' Download and Embed Map actions, opened from the hike and recording maps'
// Options menus. The map views mount both modals (#download_modal, #embed-builder-app — see
// hikes/map.html.haml and recordings/_share_modals); each opener returns false when its modal
// isn't on the page.

import { Modal } from 'bootstrap';

type DownloadWindow = { openDownloadModal?: (tab?: string) => void };
type ModalApi = { getOrCreateInstance: (el: Element) => { show: () => void } };

export const EMBED_BUILDER_MODAL_ID = 'embed-builder-modal';

/** Opens the Download modal (DownloadModal.vue publishes `window.openDownloadModal` on mount). */
export function openMapDownloadModal(win: DownloadWindow = window as DownloadWindow): boolean {
  if (typeof win.openDownloadModal !== 'function') return false;
  win.openDownloadModal();
  return true;
}

/** Opens the Embed Map builder (EmbedBuilderModal.vue's Bootstrap modal). */
export function openMapEmbedBuilder(doc: Document = document, modal: ModalApi = Modal): boolean {
  const el = doc.getElementById(EMBED_BUILDER_MODAL_ID);
  if (!el) return false;
  modal.getOrCreateInstance(el).show();
  return true;
}
